import { AxiosError } from 'axios';
import { API_BASE_URL } from 'constants/urls';

export const isMantaCareError = (error: any): boolean => {
    return error.config?.baseURL === API_BASE_URL;
};

export const isServerError = (error: AxiosError): boolean => {
    return !!error.response?.status && error.response.status >= 500;
};

export const checkErrorCode = (error: AxiosError, code: number): boolean => {
    return !!error.response?.status && error.response.status === code;
};

export const isNetworkTimedOut = (error: AxiosError): boolean => {
    return !error.response;
};
